import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnouncementComponent } from './announcement.component';
import { EdAssistUIReadMoreOrLessModule } from '@edassist-ui/read-more-or-less';
import { EdAssistUIPipesModule, StripHtmlPipe } from '@edassist-ui/pipes';
import { EdAssistUILoadingContainerModule } from '@edassist-ui/loading-container';

@NgModule({
	declarations: [AnnouncementComponent],
	imports: [
		CommonModule,
		EdAssistUIReadMoreOrLessModule,
		EdAssistUIPipesModule,
		EdAssistUILoadingContainerModule
	],
	providers: [StripHtmlPipe],
	exports: [AnnouncementComponent]
})
export class AnnouncementModule {}
